const ReportLog = () =>
  import(/* webpackChunkName: "log" */ '@/pages/log/index.vue')
const LogDetail = () =>
  import(/* webpackChunkName: "log" */ '@/pages/log/detail.vue')

import audit from './audit'
import exception from './exception'
import operationEditor from './operation-editor'
import operationAnonymous from './operation-anonymous'
import webService from './web-service'

export default {
  name: 'log',
  path: 'log',
  meta: { label: 'log' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    audit,
    exception,
    operationEditor,
    operationAnonymous,
    webService,

    // other logs
    {
      name: 'LogReport',
      path: ':category/:section',
      meta: { label: 'Index' },
      component: ReportLog,
      props: true
    },
    {
      name: 'LogDetail',
      path: ':category/:section/detail/:id',
      meta: { label: 'detail' },
      component: LogDetail,
      props: true
    }
  ]
}
